/*
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * External dependencies
 */
import { _x } from '@web-stories-wp/i18n';
import PropTypes from 'prop-types';

const title = _x('Potatoes', 'sticker name', 'web-stories');

function Potatoes({ style }) {
  return (
    <svg
      style={style}
      viewBox="0 0 87 73"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{title}</title>
      <path
        d="M32.4994 18.4997C36.4994 16.8997 45.8327 26.1664 49.9994 30.9997C55.9996 30.4998 68.5 29.4 70.5 29C73 28.5 79.5 25 83.5 31.5C87.5 38 81 48 75 52.5C75 65.5 64 73 46 69.5C31.6 66.7 28.3333 53.3333 28.5 47C27.6665 46.8333 25.3994 44.6 22.9994 37C19.9994 27.5 27.4994 20.4997 32.4994 18.4997Z"
        fill="#FFFEB2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M39.3219 19.2546C44.212 22.0006 48.8832 26.9295 51.69 30.5868L49.31 32.4132C46.6168 28.9039 42.238 24.3327 37.8531 21.8704C35.6596 20.6387 33.6245 20.0256 31.8822 20.1743C30.2361 20.3147 28.6442 21.1511 27.2634 23.3086C24.3168 27.9127 24.0862 32.5272 24.9989 36.4746C25.9214 40.4641 28.0094 43.7381 29.6077 45.4886L27.3923 47.5114C25.4906 45.4286 23.1286 41.7025 22.076 37.1504C21.0138 32.5561 21.2832 27.0873 24.7366 21.6914C26.5558 18.8489 28.9389 17.4145 31.6272 17.1851C34.2192 16.964 36.8779 17.8821 39.3219 19.2546Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.0384 39.0005C45.106 39.1304 50.8911 40.5516 54.8638 41.5448L54.9196 41.5587L54.9742 41.5769C57.4374 42.3978 59.9868 42.7749 62.5368 43.1521C62.9332 43.2107 63.3297 43.2694 63.7258 43.3297C66.5664 43.7621 69.495 44.291 71.7951 45.7286C74.0592 47.1436 75.3337 48.8091 75.8861 50.8606C76.4069 52.7952 76.2385 54.9385 75.991 57.1662C75.7107 59.6886 74.336 64.2097 70.2823 67.6449C66.1734 71.1271 59.5623 73.2843 49.2414 71.4781C38.9259 69.6729 33.0933 65.3532 30.1912 60.1707C27.3201 55.0435 27.4864 49.3695 28.5448 45.1362C29.1751 42.6148 30.826 40.998 32.9501 40.0769C35.0056 39.1856 37.5078 38.9356 40.0384 39.0005ZM34.1436 42.8293C32.7365 43.4395 31.8249 44.3852 31.4552 45.8638C30.5135 49.6305 30.4299 54.4568 32.8088 58.7049C35.1567 62.8977 40.074 66.8282 49.7586 68.523C59.4377 70.2169 65.0767 68.1241 68.3428 65.3562C71.6642 62.5415 72.7896 58.8126 73.0093 56.8349C73.2618 54.5626 73.3434 52.956 72.9892 51.6405C72.6665 50.4421 71.9411 49.3576 70.2051 48.2726C68.5053 47.2102 66.1837 46.7384 63.2742 46.2955C62.9002 46.2385 62.5176 46.1822 62.1279 46.1248C59.6112 45.7541 56.7975 45.3396 54.0813 44.4415C50.0592 43.4363 44.6227 42.119 39.9615 41.9995C37.6172 41.9394 35.6194 42.1894 34.1436 42.8293Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M72.2753 29.9268C69.837 30.7176 65.9744 31.7358 57.6358 32.4938C51.2126 33.0778 47.0845 34.6481 44.5472 36.2752C41.9728 37.926 41.1152 39.5726 40.9709 40.2942L38.0291 39.7058C38.3848 37.9274 39.9272 35.674 42.9278 33.7498C45.9655 31.8019 50.5874 30.1222 57.3642 29.5062C65.5256 28.7642 69.163 27.7824 71.3497 27.0732C71.6497 26.9759 71.9425 26.8763 72.2289 26.7789C72.9372 26.5379 73.6067 26.3101 74.2517 26.1627C75.2545 25.9335 76.264 25.8689 77.6493 26.0074C80.8092 26.3234 83.4368 28.6444 84.9041 31.5789C86.3892 34.5488 86.8137 38.3624 85.4 42.0379C83.1072 47.9992 78.3836 52.0519 76.639 53.5487C76.3669 53.7822 76.1673 53.9534 76.0607 54.0601L73.9393 51.9388C74.1367 51.7414 74.4376 51.4789 74.8133 51.1512C76.7402 49.47 80.6337 46.0732 82.6 40.961C83.6863 38.1365 83.3608 35.2003 82.2209 32.9206C81.0632 30.6053 79.1908 29.1766 77.3507 28.9926C76.236 28.8811 75.558 28.9415 74.9202 29.0873C74.4316 29.199 73.985 29.3511 73.3671 29.5617C73.0558 29.6678 72.7009 29.7888 72.2753 29.9268Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.8 24.4C38.1314 24.8418 38.0418 25.4686 37.6 25.8L33.6 28.8C33.1582 29.1314 32.5314 29.0418 32.2 28.6C31.8686 28.1582 31.9582 27.5314 32.4 27.2L36.4 24.2C36.8418 23.8686 37.4686 23.9582 37.8 24.4Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M58.8 60.4C59.1314 60.8418 59.0418 61.4686 58.6 61.8L54.6 64.8C54.1582 65.1314 53.5314 65.0418 53.2 64.6C52.8686 64.1582 52.9582 63.5314 53.4 63.2L57.4 60.2C57.8418 59.8686 58.4686 59.9582 58.8 60.4Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M79.8 39.4C80.1314 39.8418 80.0418 40.4686 79.6 40.8L75.6 43.8C75.1582 44.1314 74.5314 44.0418 74.2 43.6C73.8686 43.1582 73.9582 42.5314 74.4 42.2L78.4 39.2C78.8418 38.8686 79.4686 38.9582 79.8 39.4Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.3218 37.0716C33.0056 37.5244 32.3822 37.6352 31.9294 37.3191L27.4275 34.1761C26.9747 33.8599 26.8639 33.2365 27.18 32.7837C27.4962 32.3309 28.1196 32.22 28.5724 32.5362L33.0743 35.6792C33.5271 35.9953 33.6379 36.6187 33.3218 37.0716Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M57.9583 52.2901C57.7983 52.8187 57.24 53.1175 56.7114 52.9575L51.7103 51.4435C51.1817 51.2835 50.8829 50.7252 51.0429 50.1966C51.2029 49.668 51.7611 49.3692 52.2897 49.5293L57.2909 51.0433C57.8195 51.2033 58.1183 51.7615 57.9583 52.2901Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.7614 56.4638C37.2286 56.6092 36.6788 56.2951 36.5335 55.7622L35.0335 50.2641C34.8882 49.7312 35.2022 49.1815 35.7351 49.0361C36.2679 48.8908 36.8176 49.2049 36.963 49.7377L38.463 55.2359C38.6083 55.7687 38.2942 56.3184 37.7614 56.4638Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.7632 41.5623C63.2303 41.7076 62.6806 41.3935 62.5352 40.8607L61.0353 35.3625C60.8899 34.8297 61.204 34.2799 61.7368 34.1346C62.2696 33.9892 62.8194 34.3033 62.9647 34.8361L64.4647 40.3343C64.6101 40.8671 64.296 41.4169 63.7632 41.5623Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34 3.5H0V0.5H34C35.933 0.5 37.5 2.067 37.5 4V11.5C37.5 13.433 35.933 15 34 15H26.5C24.567 15 23 13.433 23 11.5H0V8.5H26V11.5C26 11.7761 26.2239 12 26.5 12H34C34.2761 12 34.5 11.7761 34.5 11.5V4C34.5 3.72386 34.2761 3.5 34 3.5Z"
        fill="#005CD6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M55.3931 13.4422C55.6769 13.8026 56.0077 14.1954 56.3769 14.6039C57.4936 15.8398 58.9048 17.1577 60.3418 18.1348C61.8309 19.1474 63.1103 19.6308 64.0254 19.5805C64.4335 19.558 64.7722 19.4307 65.0784 19.1681C65.4022 18.8904 65.7697 18.3907 66.0838 17.5008C66.688 15.7888 66.4049 14.9168 66.0227 14.4253C65.5648 13.8365 64.6246 13.3417 63.1199 13.0788C60.8084 12.6749 57.8338 12.9351 55.3931 13.4422ZM68.3908 12.5835C69.6012 14.1398 69.7316 16.1794 68.9128 18.4992C68.4769 19.7343 67.86 20.7347 67.0315 21.4453C66.1853 22.171 65.2038 22.5202 64.19 22.576C62.2613 22.682 60.2907 21.7279 58.6549 20.6156C56.9668 19.4677 55.378 17.9731 54.151 16.6152C53.5345 15.933 52.9953 15.2697 52.5702 14.6822C52.1641 14.1209 51.8013 13.5465 51.6056 13.057L50.9983 11.5387L52.5633 11.0645C55.4442 10.1915 60.0316 9.49376 63.6362 10.1236C65.4247 10.436 67.2562 11.1247 68.3908 12.5835ZM16.3271 19.7026L16.4956 21.8846C16.7682 25.4173 15.8366 29.3748 14.2021 31.9327C13.3967 33.1932 12.2598 34.3605 10.7734 34.7101C9.14087 35.0942 7.61524 34.3874 6.3789 32.9965C5.23914 31.7143 4.95306 30.2343 5.33229 28.7945C5.68263 27.4644 6.56817 26.2742 7.54454 25.2842C9.51185 23.2895 12.3594 21.6002 14.3528 20.6468L16.3271 19.7026ZM8.23335 29.5586C8.10529 30.0448 8.16088 30.4857 8.62112 31.0035C9.38478 31.8626 9.85936 31.8433 10.0864 31.7899C10.4597 31.702 11.0419 31.3068 11.6742 30.3173C12.5845 28.8926 13.2675 26.7412 13.4763 24.5245C12.1206 25.3376 10.7206 26.3362 9.68048 27.3908C8.86102 28.2217 8.39031 28.9627 8.23335 29.5586Z"
        fill="#005CD6"
      />
    </svg>
  );
}

Potatoes.propTypes = {
  style: PropTypes.object,
};

export default {
  aspectRatio: 87 / 73,
  svg: Potatoes,
  title,
};
